import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b712d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-footer" }

import { computed, ref, h, onMounted } from 'vue';
import { FormInstance, FormRules, ElAlert, ElMessageBox } from 'element-plus';
import { EMessage } from '@aciga/e-ui-next';
import { cloneDeep } from 'lodash';
import { getLoginProjects } from '@/api/myAuth';
import { getResourceList, createOrUpdateResource } from '@/api/resource';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';
import { resourceTypeList } from '@/config/const/resource';
import { getAllDataWithCursor } from '@/api/common';
import { getCheckUpload } from '@/utils';
import { customRequest } from '@/utils/customRequest';
import { useUserStore } from '@/store';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';

interface Props {
  drawerVisible: boolean;
  resourceInfo?: Resource.ResourceItem;
  type: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editResourceDrawer',
  props: {
    drawerVisible: { type: Boolean, default: false },
    resourceInfo: { default: () => ({
    resourceId: '系统生成，不可修改',
    resourceName: '',
    projectName: '',
    sysId: '',
    projectId: '',
    resourceType: 1,
    resourceUrl: '',
    order: 0,
    parentResourceId: 0,
    parentResourceName: '',
    icon: '',
    openMethod: 1,
    resourceStatus: 1,
    sysProId: []
  }) },
    type: { default: 'create' }
  },
  emits: ['update:drawerVisible', 'on-success'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();
const initData = {
  resourceId: '系统生成，不可修改',
  resourceName: '',
  projectName: '',
  sysId: '',
  projectId: '',
  resourceType: 1,
  resourceUrl: '',
  order: 0,
  resourceStatus: 1,
  parentResourceId: 0,
  parentResourceName: '',
  icon: '',
  openMethod: 1,
  sysProId: []
};
const props = __props;

const emit = __emit;

const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    emit('update:drawerVisible', val);
  }
});

const formRef = ref<FormInstance>();
// @ts-ignore
const formData = ref<Resource.ResourceItem>(initData);
const iconArr = ref<any[]>([]);
const systemProjectTree = ref<any[]>([]);

const formRules = ref<FormRules>({
  sysProId: [{ required: true, message: '请选择项目', trigger: ['change'] }],
  resourceName: [{ required: true, message: '请输入资源名称', trigger: ['blur', 'change'] }],
  resourceType: [{ required: true, message: '请选择资源类型', trigger: ['blur', 'change'] }],
  resourceUrl: [{ required: true, message: '请输入资源地址', trigger: ['blur', 'change'] }],
  order: [{ required: true, message: '请输入资源排序', trigger: ['blur', 'change'] }],
  resourceStatus: [{ required: true, message: '请选择资源状态', trigger: ['blur', 'change'] }],
  parentResourceId: [
    { required: true, type: 'number', message: '请选择上级资源', trigger: ['blur', 'change'] }
  ]
});

const defaultProps = {
  children: 'children',
  label: 'resourceName'
};

onMounted(() => {
  userStore.getSystemProjectsTree().then((res) => {
    systemProjectTree.value = res;
  });
});

const checkUploadImage = getCheckUpload({
  // 允许的上传格式 例如-['image/jpeg', 'image/jpg', 'image/png']
  allowType: ['image/png'],
  // 类型不匹配错误提示
  typeErrorMessage: '上传图片只能是PNG格式',
  // 大小限制 MB 级别
  sizeLimit: (1 / 1024) * 100,
  // 大小不匹配错误提示
  sizeErrorMessage: '图片大小不能超过100K',
  type: 'image',
  // 图片则可能有宽度限制， 无穷小：-Infinity；无穷大: Infinity [800, Infinity]
  widthLimit: [20, Infinity],
  // 图片则可能有高度限制
  heightLimit: [20, Infinity],
  // 宽高不匹配错误提示
  widthHeightErrorMessage: '图片尺寸宽高>=20*20px'
});

const uploadResourceIconSuccess = (response: string) => {
  formData.value.icon = response;
  iconArr.value = [{ name: '', url: response }];
  console.log('iconArr:', iconArr);
  if (formRef.value) {
    formRef.value.clearValidate('icon');
  }
};

const uploadResourceIconError = () => {
  formData.value.icon = '';
  iconArr.value = [];
};

const delResourceIcon = () => {
  formData.value.icon = '';
  iconArr.value = [];
};

const onCancel = () => {
  // @ts-ignore
  ElMessageBox.confirm(
    h(ElAlert, {
      title: props.type === 'create' ? '确认取消创建' : '确认取消编辑',
      type: 'warning',
      showIcon: true,
      closable: false
    }),
    props.type === 'create' ? '取消创建资源' : '取消编辑资源',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      customClass: 'e-message-box e-theme-cm',
      confirmButtonClass: 'e-button el-button--main e-theme-cm',
      cancelButtonClass: 'e-button el-button--secondary e-theme-cm',
      effect: 'cm'
    }
  ).then(async () => {
    drawerShow.value = false;
  });
};

const saveLoading = ref(false);
const saveOrUpdate = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      // 处理parentResourceId
      saveLoading.value = true;
      const targetProject = projectList.value.find(
        (project) => project.projectId === formData.value.projectId
      );
      if (targetProject) {
        formData.value.projectName = targetProject.projectName;
      }
      const params = { ...formData.value };
      // 格式化网络请求的参数
      if (props.type === 'create') {
        delete params.resourceId;
      }
      if (params.parentResourceId === '') {
        params.parentResourceId = 0;
      }
      try {
        const res = await createOrUpdateResource(params);
        const { code } = res || {};
        if (`${code}` === '0') {
          EMessage.success('保存成功');
          drawerShow.value = false;
          emit('on-success');
        }
        saveLoading.value = false;
      } catch (err) {
        saveLoading.value = false;
      }
    }
  });
};
// 父级资源树
const parentResourceList = ref<Resource.ResourceItem[]>([]);
// 全量资源树
let allResources: Resource.ResourceItem[] = [];
// 扁平化资源map
const allFlatResourceMap = new Map<number | string, Resource.ResourceItem>();
// 全量项目
const projectList = ref<Project.ProjectItem[]>([]);

const onOpened = async () => {
  const { resourceInfo } = props;
  formData.value = resourceInfo;
  const { sid, projectId } = resourceInfo as any;
  formData.value.sysProId = [sid, projectId];
  if (resourceInfo.icon) {
    iconArr.value = [{ name: '', url: resourceInfo.icon }];
  }
  // 获取项目
  const res = await getLoginProjects();
  const { code, data } = res;
  if (`${code}` === '0') {
    projectList.value = data.loginProject;
  }
  if (props.type === 'edit') {
    // 获取所有资源
    getParentResourceData();
  }
};

const getParentResourceData = async () => {
  const { projectId } = formData.value;
  const res = await getAllDataWithCursor(
    getResourceList,
    {
      projectIds: [projectId],
      page: { cursor: 0 }
    },
    'resources'
  );
  const { code, data } = res || {};
  if (`${code}` === '0') {
    allResources = makeAllTreeData(cloneDeep(data.resources));
    parentResourceList.value = filterResourceList(formData.value.resourceType);
    console.log('parentResourceList:', parentResourceList.value);
  }
};
const makeAllTreeData = (flatValidList: Resource.ResourceItem[]) => {
  const tree: Resource.ResourceItem[] = [];
  const treeDataMap = new Map<number, Resource.ResourceItem>(); // 内容会被改变

  flatValidList.forEach((item) => {
    allFlatResourceMap.set(item.resourceId as number, item);
    treeDataMap.set(item.resourceId as number, cloneDeep(item)); // 中途会修改item
  });

  flatValidList
    .map((e) => e.resourceId)
    .forEach((rId: any) => {
      const item = treeDataMap.get(rId);
      if (item) {
        // 根节点
        if (item?.parentResourceId === 0) {
          tree.push(item);
        } else {
          const parent = treeDataMap.get(item!.parentResourceId as number);
          parent!.children = parent?.children ? parent?.children.concat(item) : [item];
        }
      }
    });
  return tree;
};

// 只要满足目标层级的上级资源数据，3 可以支持1，2
const filterResourceList = (level: number) => {
  // 没有限制，返回全部
  if (!level) {
    return allResources;
  }
  let leafLevelArr;
  if (level === 3) {
    leafLevelArr = [1, 2];
  } else {
    leafLevelArr = [level - 1];
  }
  const tree: Resource.ResourceItem[] = [];
  const nodeIds = [];
  const filterFlatResourceMap = new Map<number | string, Resource.ResourceItem>();
  for (const rItem of allFlatResourceMap.values()) {
    if (leafLevelArr.includes(rItem.resourceType)) {
      nodeIds.push(rItem.resourceId);
      filterFlatResourceMap.set(rItem.resourceId as number, cloneDeep(rItem));
    }
  }
  // 依据map 和 nodeIds 生成树
  nodeIds.forEach((rId) => {
    const node = filterFlatResourceMap.get(rId as number);
    if (node) {
      // 已经是一级节点
      if (node.parentResourceId === 0) {
        tree.push(node);
      } else {
        const parentNode = filterFlatResourceMap.get(node.parentResourceId);
        if (parentNode) {
          parentNode.children = (parentNode?.children || []).concat(node);
        }
      }
    }
  });
  return tree;
};

// 格式化4，查到所有的3
const filterResourceList3 = () => {
  const tree: Resource.ResourceItem[] = [];
  for (const rItem of allFlatResourceMap.values()) {
    if (rItem.resourceType === 3) {
      tree.push(rItem);
    }
  }
  return tree;
};

const onChangeProject = () => {
  const { sysProId } = formData.value;
  const [sysId, projectId] = sysProId;
  if (!projectId || !sysId) {
    console.error('获取系统id，或者项目id失败');
    return;
  }
  formData.value.projectId = projectId;
  formData.value.sysId = sysId;
  getParentResourceData();
};

const onChangeResourceType = (resourceType: number) => {
  formData.value.parentResourceId = '';
  console.log('onChangeResourceType:', resourceType);
  // resourceType 1，2，3，4  3 页面可以挂在 1，2 下面
  if (resourceType === 4) {
    parentResourceList.value = filterResourceList3();
  } else {
    parentResourceList.value = filterResourceList(resourceType);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_e_cascader = _resolveComponent("e-cascader")!
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_option = _resolveComponent("e-option")!
  const _component_e_select = _resolveComponent("e-select")!
  const _component_e_input_number = _resolveComponent("e-input-number")!
  const _component_e_radio = _resolveComponent("e-radio")!
  const _component_e_radio_group = _resolveComponent("e-radio-group")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_e_typography = _resolveComponent("e-typography")!
  const _component_e_upload = _resolveComponent("e-upload")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_button = _resolveComponent("e-button")!

  return (_openBlock(), _createBlock(EDrawer, {
    modelValue: drawerShow.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((drawerShow).value = $event)),
    direction: "rtl",
    title: _ctx.type === 'create' ? '添加资源' : '编辑资源',
    size: "45%",
    "show-footer": true,
    "show-close": false,
    onOpened: onOpened
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.type === 'create')
          ? (_openBlock(), _createBlock(_component_e_button, {
              key: 0,
              loading: saveLoading.value,
              type: "main",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (saveOrUpdate(formRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("创建")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.type !== 'create')
          ? (_openBlock(), _createBlock(_component_e_button, {
              key: 1,
              loading: saveLoading.value,
              type: "main",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (saveOrUpdate(formRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_e_button, {
          type: "secondary",
          onClick: onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_e_form, {
        ref_key: "formRef",
        ref: formRef,
        rules: formRules.value,
        model: formData.value,
        "label-width": "90px",
        "label-position": "right",
        "show-ellipsis": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_form_item, {
            label: "项目名称",
            prop: "sysProId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_cascader, {
                modelValue: formData.value.sysProId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.sysProId) = $event)),
                options: systemProjectTree.value,
                placeholder: "请选择项目",
                onChange: onChangeProject
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源ID",
            prop: "resourceId"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.resourceId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.resourceId) = $event)),
                disabled: "",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源名称",
            prop: "resourceName"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.resourceName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.resourceName) = $event)),
                placeholder: "请输入资源名称",
                clearable: "",
                maxlength: 50
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源类型",
            prop: "resourceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_select, {
                modelValue: formData.value.resourceType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.resourceType) = $event)),
                disabled: _ctx.type === 'edit',
                placeholder: "请选择资源类型",
                onChange: onChangeResourceType
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourceTypeList), (item) => {
                    return (_openBlock(), _createBlock(_component_e_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源url",
            prop: "resourceUrl"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.resourceUrl,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.resourceUrl) = $event)),
                placeholder: "请输入资源地址",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源排序",
            prop: "order"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_input_number, {
                modelValue: formData.value.order,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.order) = $event)),
                placeholder: "请输入资源地址",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "资源状态",
            prop: "resourceStatus"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_radio_group, {
                modelValue: formData.value.resourceStatus,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.resourceStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_e_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("启用")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_e_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("禁用")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (formData.value.resourceType !== 1)
            ? (_openBlock(), _createBlock(_component_e_form_item, {
                key: 0,
                label: "上级资源",
                prop: "parentResourceId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    modelValue: formData.value.parentResourceId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.parentResourceId) = $event)),
                    data: parentResourceList.value,
                    "render-after-expand": false,
                    placeholder: "请选择上级资源",
                    "check-strictly": formData.value.resourceType === 3,
                    "node-key": "resourceId",
                    props: defaultProps
                  }, null, 8, ["modelValue", "data", "check-strictly"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_e_form_item, {
            label: "菜单icon",
            prop: "icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_upload, {
                "file-list": iconArr.value,
                "before-upload": _unref(checkUploadImage),
                "on-success": uploadResourceIconSuccess,
                "on-error": uploadResourceIconError,
                "before-remove": delResourceIcon,
                accept: ".png",
                class: _normalizeClass({
            hide_card: iconArr.value.length === 1
          }),
                "http-request": _unref(customRequest),
                "list-type": "picture-card"
              }, {
                tip: _withCtx(() => [
                  _createVNode(_component_e_typography, {
                    heading: "5",
                    class: "image-desc",
                    type: "placeholder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传图片固定尺寸,支持PNG,大小不超过100K,图片尺寸宽高>=20*20px ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "before-upload", "class", "http-request"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "菜单打开",
            prop: "openMethod"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_radio_group, {
                modelValue: formData.value.openMethod,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.openMethod) = $event)),
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_e_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("原窗口打开")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_e_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("新窗口打开")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})